import {Box, css, styled} from '@mui/material';
import {StyledCard} from 'presentation/components';
import {AppointmentCardContainerProps, AppointmentDetailsHeaderProps} from './types';

export const Container = styled(Box)`
	padding: 16px;
	height: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

export const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 110px;
	}
`;

export const AppointmentCardContainer = styled(StyledCard.Container)<AppointmentCardContainerProps>`
	height: 100%;
	justify-content: unset;
	min-width: 317px;

	${({$borderColor}) =>
		$borderColor &&
		css`
			border-top: 4px solid ${$borderColor};
		`}

	@media (max-width: 320px) {
		min-width: 285px;
	}
`;

export const AppointmentDetailsCardContainer = styled(StyledCard.Container)`
	border-radius: 4px;
	flex: 1;
	justify-content: initial;

	${({theme}) => theme.breakpoints.down('md')} {
		border-radius: 0;
	}
`;

export const AppointmentDetailsHeader = styled(
	AppointmentDetailsCardContainer,
)<AppointmentDetailsHeaderProps>`
	${({$borderColor}) =>
		$borderColor &&
		css`
			border-bottom: 4px solid ${$borderColor};
		`}
`;
